import { FilterProps } from "react-table";

export function TextColumnFilter<T extends object>({
  column: { filterValue, setFilter },
}: FilterProps<T>) {
  return (
    <input
      type="text"
      className="mt-[10px] w-full rounded bg-lightWhiteGray p-[5px] font-normal outline-none"
      placeholder="Поиск"
      value={filterValue ?? ""}
      onChange={(e) => setFilter(e.target.value || undefined)}
    />
  );
}
